// Red / Yellow / Green status model shared across Home → Workspace → Card → Task.
// Task: green = done · red = open & overdue · yellow = open & on-track.
// Aggregate: red if any red · else yellow if any open · else green (all done / empty).

export const todayStr = () => new Date().toISOString().slice(0, 10);

export const taskRYG = (t, today = todayStr()) => {
  if (t.status === 'done') return 'green';
  const d = t.due_date ? String(t.due_date).slice(0, 10) : '';
  if (d && d < today) return 'red';
  return 'yellow';
};

// counts: { red, yellow, green } (yellow = open & on-track)
export const aggregateRYG = ({ red = 0, yellow = 0 }) => (red > 0 ? 'red' : yellow > 0 ? 'yellow' : 'green');

export const rygFromTasks = (tasks, today = todayStr()) => {
  const c = { red: 0, yellow: 0, green: 0 };
  tasks.forEach(t => { c[taskRYG(t, today)] += 1; });
  return c;
};

export const RYG_META = {
  red: { key: 'red', label: 'Needs attention', color: '#B4332E', bg: 'rgba(180,51,46,0.12)' },
  yellow: { key: 'yellow', label: 'On track', color: '#B8860B', bg: 'rgba(184,134,11,0.14)' },
  green: { key: 'green', label: 'Completed', color: '#3B7A57', bg: 'rgba(59,122,87,0.14)' },
};
export const RYG_ORDER = ['red', 'yellow', 'green'];
